/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-09-19 19:35:17
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @LastEditTime: 2022-09-19 19:36:26
 * @FilePath: /pscd-portal-new-workbench/packages/clients/src/helpers/regular.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export class CustomRegulars {
}
/**
 * 特殊字符
 * @examples
 */
CustomRegulars.special_characters = /[`~!@#$%^&*+=?:"{}|,.\/;'\\[\]·~！@#￥%……&*+={}|？：“”【】、；‘'，。、]/gim;
